module.exports = __webpack_public_path__ + "static/media/user.a04d849c.jpg";